import { SOCIAL_SIGN_IN_LABELS, type SocialSignInProvider } from '../../lib/betterAuthClient';
import { Button } from '../../ui/button';

interface SocialSignInButtonsProps {
  /** Resolved from the backend — an unconfigured provider is absent, not disabled. */
  providers: SocialSignInProvider[];
  /** Only the verb differs between the two surfaces; the flow behind them is identical. */
  action: 'Sign in' | 'Sign up';
  disabled?: boolean;
  onSelect: (provider: SocialSignInProvider) => void;
}

/**
 * The social sign-in actions, and the "Or" divider that only makes sense when there is at
 * least one. Rendering nothing when the list is empty is the point: an environment without
 * credentials shows the password form alone rather than a button that dead-ends at a broken
 * consent screen.
 */
export function SocialSignInButtons({
  providers,
  action,
  disabled,
  onSelect,
}: SocialSignInButtonsProps) {
  if (providers.length === 0) return null;

  return (
    <>
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <span className="w-full border-t border-border" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-card px-2 text-muted-foreground">Or</span>
        </div>
      </div>

      <div className="space-y-3">
        {providers.map((provider) => (
          <Button
            key={provider}
            variant="outline"
            className="w-full"
            type="button"
            onClick={() => onSelect(provider)}
            disabled={disabled}
          >
            {action} with {SOCIAL_SIGN_IN_LABELS[provider]}
          </Button>
        ))}
      </div>
    </>
  );
}
